import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

import { API_URL, ENVIRONMENT } from './config'

Sentry.init({
  // dsn: SENTRY_DSN_WEB,
  dsn: 'https://bf50e7f95cb64a85b27b9ed275255582@o136426.ingest.sentry.io/301682',
  environment: ENVIRONMENT,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
      enableAsyncRouteHandlers: true,
    }),
  ],
  tracesSampleRate: 0.2,
  normalizeDepth: 11,
  // Transient stale-chunk loads after deploy; self-healed by the vite:preloadError reload in main.tsx.
  ignoreErrors: [
    /Failed to fetch dynamically imported module/i,
    /error loading dynamically imported module/i,
    /Importing a module script failed/i,
    /Unable to preload CSS/i,
    /'text\/html' is not a valid JavaScript MIME type/i,
    // Bots/scanners probe asset-ish paths (/.js, /.css, /.png); React Router throws a
    // 404 "No route matches URL". Real users hit the catch-all `*` NotFound route instead,
    // so this only ever fires for path-probing noise. [RDM-FRONTEND-3JN][RDM-FRONTEND-33Y]
    /No route matches URL/i,
  ],
  // enabled: ENVIRONMENT !== 'local',
  tunnel: `${API_URL}/sentry`,
  // Expected auth outcomes, not bugs — dropped centrally so the many
  // `catch (error) { Sentry.captureException(error) }` blocks across the app don't each need a guard:
  //   HTTP_401  — errorFromResponse tags it; handleUnauthorized redirects to /session-expired.
  //   FORBIDDEN — structured 403, e.g. editing a record you don't own; surfaced via snackbar. [RDM-FRONTEND-3NV]
  beforeSend(event, hint) {
    const error = hint?.originalException
    const code = error && typeof error === 'object' ? (error as { code?: string }).code : undefined
    if (code === 'HTTP_401' || code === 'FORBIDDEN') {
      return null
    }
    return event
  },
})

export default Sentry
